const tokenCount = 10420;
const counts = {
    1: 0,
    2: 0,
    3: 0,
}
const tokenNames = [];




const posterNumToName = {
    1: "70's",
    2: "90's",
    3: "SciFi",
}

function fnv32a() {
    let str = JSON.stringify(arguments);
    let hval = 0x811c9dc5;
    for ( let i = 0; i < str.length; ++i )
    {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    return hval >>> 0;
}

export function tokenName(_tokenId){

    if(_tokenId >= tokenCount){
        return "---TOKEN NAME NOT FOUND---";
    }else{
        return tokenNames[_tokenId];
    }
}

// function generateName(tokenId,posterNum){
//     tokenNames.push(
//         "#"+tokenId+" Stoner Cats Poster "+posterNum
//     );
// }

function posterName(posterNum,index){
    return "#"+index+" " + posterNumToName[posterNum] + " Stoner Cats Poster";
}

for(let i = 0; i < tokenCount; i++){
    let posterNum = fnv32a(i,"420 Baby")%3 + 1;

    // tokenNames.push(
    //     "#"+counts[posterNum]+" Stoner Cats Poster "+posterNum
    // );

    tokenNames.push(
        posterName(posterNum,counts[posterNum])
    );

    // generateName(i,posterNum);
    counts[posterNum]++;
}
